import React from 'react';
import CarouselItem from '../../shared/components/carousel/CarouselItem';
import Carousel2 from '../../shared/components/carousel/Carousel2';

const CarouselWithAllClients2: React.FC = () => (
  <Carousel2>
    <CarouselItem>
      <img src={require('./images/clients/merrill-logo.png')} alt="" />
    </CarouselItem>

    <CarouselItem>
      <img src={require('./images/clients/jpmorgan-logo.png')} alt="" />
    </CarouselItem>

    <CarouselItem>
      <img src={require('./images/clients/citi-logo.png')} alt="" />
    </CarouselItem>
  </Carousel2>
);

export default CarouselWithAllClients2;
